__turbopack_context__.v({
  "leaderBoardwrapper": "Leaderboard-module__TDdgHG__leaderBoardwrapper",
});
